import React, { useEffect, useRef, useCallback } from 'react';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import DropzoneComponent from 'react-dropzone-component';
import showToaster from '../../../../helpers/toastrMessgaes/showToaster';
import uploadIcon from '/public/dashboard/uploadIcon.svg';

const Dropzone = ({
    className,
    inputContainer,
    maxUploadSize,
    componentConfig,
    fieldName,
    iconClass,
    handleDropzone,
    isLoader,
    setImageLoader,
    formName,
    reviewImages
}) => {
    const dropzoneRef = useRef(null);

    useEffect(() => {
        const isBrowser = typeof window !== 'undefined';
        const isDocument = typeof document !== 'undefined';
        if (isBrowser && isDocument) {
            const input = document.querySelector(".dz-hidden-input");
            if (input) {
                input.style.visibility = 'visible';
                input.style.opacity = '0';
                input.style.cursor = 'pointer';
            }
        }
    });

    const success = async (file, fromServer) => {
        const fileName = fromServer.fileName;
        await handleDropzone(fileName, fieldName, formName);
        setImageLoader(file.upload.filename);
        dropzoneRef.current.removeFile(file);
    };

    const error = (file) => {
        setImageLoader(file.upload.filename);
        dropzoneRef.current.removeFile(file);
    };

    const addedfile = async (file) => {
        let fileTypes = fieldName === 'favicon'
            ? ['image/png']
            : ['image/jpeg', 'image/png', 'image/jpg'];
        let isOnline = typeof window !== 'undefined' && window.navigator.onLine;

        setImageLoader(file.upload.filename);

        if (reviewImages.length >= 20) {
            showToaster({ messageId: 'maxReviewPhotoUpload', toasterType: 'error' });
            dropzoneRef.current.removeFile(file);
            setImageLoader(null);
            return;
        }

        if (!isOnline) {
            showToaster({ messageId: 'networkFailed', toasterType: 'error' });
            dropzoneRef.current.removeFile(file);
            setImageLoader(null);
            return;
        }

        if (file?.size > (1024 * 1024 * parseInt(maxUploadSize))) {
            showToaster({ messageId: 'limitError', requestContent: maxUploadSize, toasterType: 'error' });
            dropzoneRef.current.removeFile(file);
            setImageLoader(null);
            return;
        }

        if (!fileTypes.includes(file.type)) {
            showToaster({ messageId: 'filetypeError', toasterType: 'error' });
            dropzoneRef.current.removeFile(file);
            setImageLoader(null);
        }

    };

    const queueComplete = useCallback(() => {
        setImageLoader(null);
    }, [setImageLoader]);

    const djsConfig = {
        dictDefaultMessage: '',
        addRemoveLinks: false,
        maxFilesize: parseInt(maxUploadSize),
        acceptedFiles: 'image/jpeg, image/png, image/jpg',
        dictMaxFilesExceeded: 'Remove the existing image and try upload again',
        previewsContainer: false,
        hiddenInputContainer: inputContainer,
        timeout: 300000,
        maxFiles: 20,
    };

    const eventHandlers = {
        init: dz => dropzoneRef.current = dz,
        success,
        addedfile,
        error,
        queuecomplete: queueComplete
    };

    return (
        <div className={cx("positionRelative", className)}>
            <DropzoneComponent
                config={componentConfig}
                eventHandlers={eventHandlers}
                djsConfig={djsConfig}
                maxfilesexceeded={true}
                className={fieldName}
            />
            <img src={uploadIcon} className={iconClass} alt="Upload Icon" />
        </div>
    );
};


export default withStyles()(Dropzone);